module.exports = __webpack_public_path__ + "static/media/blank_person.ff376220.png";